module.exports = {
  InputText: {
    PluginName: "Introducir valor",
    content_box_name: "Contenedor  ",
    fontSize: "Tamaño de letra",
    answerType: "Tipo de respuesta",
    Precision: "Máx. error permitido",
    Placeholder: "Introduce la respuesta esperada",
    Characters: "Ignorar mayús. y tildes",
    General: "Avanzado",
    text: "Texto",
    number: "Número",
    notCount: "Este ejercicio no añade puntos a la nota",
  },
};
